import { render, staticRenderFns } from "./MyAbsencesPage.vue?vue&type=template&id=50cf740b"
import script from "./MyAbsencesPage.vue?vue&type=script&lang=js"
export * from "./MyAbsencesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports